import ScriptText from "./ScriptText";

interface SectionHeadingProps {
  scriptAccent?: string;
  heading: string;
  className?: string;
  centered?: boolean;
}

export default function SectionHeading({
  scriptAccent,
  heading,
  className = "",
  centered = true,
}: SectionHeadingProps) {
  return (
    <div className={`mb-12 ${centered ? "text-center" : ""} ${className}`}>
      {scriptAccent && (
        <ScriptText className="mb-3 block text-3xl lg:text-4xl">{scriptAccent}</ScriptText>
      )}
      <h2 className="font-serif font-light tracking-wide text-soft-charcoal">{heading}</h2>
    </div>
  );
}
